exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fd4CfvQaUe7aREA1pLIm8{font-size:12px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;white-space:pre-wrap}.fd4CfvQaUe7aREA1pLIm8._9xgq-yPr3pTf_-AdwSZRk{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fd4CfvQaUe7aREA1pLIm8._9xgq-yPr3pTf_-AdwSZRk,._9xgq-yPr3pTf_-AdwSZRk{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
// Exports
exports.locals = {
	"container": "fd4CfvQaUe7aREA1pLIm8",
	"singleLine": "_9xgq-yPr3pTf_-AdwSZRk"
};